import 'antd/dist/antd.css'
import 'react-phone-input-2/lib/style.css';
import "./Colors.css";
import "antd/dist/antd.less"; // import official less entry file
import "./custom-antd.less"; // override variables here
import "./override-css.css"; // override variables here
import React, {Component} from 'react';
import {Route, Switch} from 'react-router-dom';
import './App.css';
import NotFound from "./container/NotFound";
import SignupComponent from "./container/CreateUser/SignupComponent";
import EnterOtp from "./container/Login/EnterOtp";
import SignupVerify from "./container/CreateUser/SignupVerify";
import Spare from "./container/CreateUser/Spare";
import Landing from "./container/Login/Landing";
import Dashboard from "./container/Dashboard";
import LoginComponent from "./container/Login/LoginComponent";
import Profile from "./container/Profile"
import Help from "./container/AccountSettings/Help"
import ChatPage from "./container/AccountSettings/ChatPage"
import EditProfile from "./container/AccountSettings/EditProfile"
import CardDetails from "./container/CreateUser/CardDetails"
import ForgotPassword from './container/Login/ForgotPassword';
import FAQ from "./container/AccountSettings/FAQ"
import History from "./container/AccountSettings/History"
import ChangePassword from "./container/AccountSettings/ChangePassword"
import ChangePin from "./container/AccountSettings/ChangePin"
import Promo from "./container/AccountSettings/Promo"
import VerificationPin from './container/PickUpCash/VerificationPin';
import SignupFlow from "./container/CreateUser/SignupFlow";
import EnterLoginOtp from "./container/Login/EnterLoginOtp";
import { BrowserRouter } from 'react-router-dom/cjs/react-router-dom.min';
import { GlobalStateProvider } from './state/GlobalStateProvider';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import AddToBalance from './container/AddToBalance/AddToBalance';
import FundAccountStripe from './container/AddToBalance/FundAccountStripe';
import FundAccountPaypal from './container/AddToBalance/FundAccountPaypal';
import DepositReturn from './container/AddToBalance/DepositReturn';
import ChaseDemoFlow from "./container/ChaseDemoFlow";
import TheBankDemoFlow from "./container/TheBankDemoFlow";
import DemoBarcode from './DemoBarcode';

class App extends Component {

    render() {
        return (
            <GlobalStateProvider>
            <BrowserRouter>
            <div className="App">
                <Switch>
                    <Route exact path='/' component={Landing}/>
                    <Route exact path='/login' component={LoginComponent}/>
                    <Route exact path='/login-otp' component={EnterLoginOtp}/>
                    <Route exact path='/forgotpassword' component={ForgotPassword}/>
                    <Route exact path='/signup' component={SignupComponent}/>
                    <Route path='/signup-flow' component={SignupFlow}/>
                    <Route exact path="/verification-pin" component={VerificationPin}/>
                    <Route path='/enter-otp' component={EnterOtp}/>
                    <Route exact path='/signup-verify' component={SignupVerify}/>
                    <Route exact path='/spare' component={Spare}/>
                    <Route path='/dashboard' component={Dashboard}/>
                    <Route exact path='/profile' component={Profile}/>
                    <Route exact path='/edit-profile' component={EditProfile}/>
                    <Route exact path='/change-password' component={ChangePassword}/>
                    <Route exact path='/change-pin' component={ChangePin}/>
                    <Route exact path='/promo' component={Promo}/>
                    <Route exact path='/add-to-balance' component={AddToBalance}/>
                    <Route exact path='/fund-account-stripe' component={FundAccountStripe}/>
                    <Route exact path="/fund-account-paypal" component={FundAccountPaypal} />
                    <Route exact path="/deposit/return" component={DepositReturn} />
                    <Route path='/card-details' component={CardDetails}/>
                    <Route exact path='/history' component={History}/>
                    <Route exact path='/help' component={Help}/>
                    <Route exact path='/chat' component={ChatPage}/>
                    <Route exact path='/faq' component={FAQ}/>
                    <Route exact path='/demo/bank-iframe' component={ChaseDemoFlow}/>
                    <Route exact path='/demo/the-bank' component={TheBankDemoFlow}/>
                    <Route exact path='/demo/the-bank/cash-in' component={TheBankDemoFlow}/>
                    <Route exact path='/demo/barcode/:method/:amount' component={DemoBarcode}/>
                    <Route exact path='/demo/barcode/:amount' component={DemoBarcode}/>
                    <Route exact path="/" component={Landing} />
                    <Route exact path='*' component={NotFound}/>
                </Switch>
            </div>
            </BrowserRouter>
            </GlobalStateProvider>
        );
    }
}

export default App;
